import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import ThreeIconsMenu from "./ThreeIconsMenu";
import BottomInfoBar from "./BottomInfoBar";
import ContentWrapper from "./ContentWrapper";
import { connect } from "react-redux";
import { initialCalls } from "../actions/initialCalls";
import { getCasesAndProjects } from "../actions/cases";
import { getDefaultParams } from "../actions/create";
import { getLoads } from "../actions/loads";
import { getConfigurationsMap } from "../actions/configurations";

export const Dashboard = (props) => {
  const [loadedUser, setLoadedUser] = useState(false);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      // do here all initial calls, pass functions without ()
      props.initialCalls(
        props.getCasesAndProjects,
        props.getDefaultParams,
        props.getLoads,
        props.getConfigurationsMap
      );
      setLoadedUser(true);
    }
  }, []);

  return (
    <React.Fragment>
      {loadedUser ? (
        <React.Fragment>
          <CssBaseline />
          {/* Three Buttons on top right */}
          <ThreeIconsMenu></ThreeIconsMenu>

          {/* Display content of page, also with sidebar */}
          <ContentWrapper></ContentWrapper>

          {/* Bottom info bar */}
          <BottomInfoBar></BottomInfoBar>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  initialCalls,
  getCasesAndProjects,
  getDefaultParams,
  getLoads,
  getConfigurationsMap,
})(Dashboard);
